<template>
	<div
		class="carousel_arrow"
		:class="[{'next': direction === 'next', 'prev': direction === 'prev'}, theme]"
	>

		<svg
			v-if="direction === 'prev'"
			width="23"
			height="18"
			viewBox="0 0 23 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.4435 1.41327L4.19348 7.63544L22.3235 7.63544L22.3235 9.63544L4.05449 9.63544L10.4445 15.9982L9.03349 17.4152L0.285493 8.70624L1.34949 7.64667L1.34949 7.63641L1.35948 7.63641L9.03249 -0.00274774L10.4435 1.41327Z"
				fill="white"
			/>
		</svg>

		<svg
			v-if="direction === 'next'"
			width="23"
			height="18"
			viewBox="0 0 23 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5778 15.9992L18.8278 9.77704H0.697754V7.77704H18.9668L12.5768 1.41425L13.9877 -0.00274658L22.7357 8.70624L21.6718 9.76581V9.77606H21.6618L13.9888 17.4152L12.5778 15.9992Z"
				fill="white"
			/>
		</svg>

	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		direction: {
			default: 'next',
		},
		theme: {
			default: 'light',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.carousel_arrow {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background: #dba769;
	transition: 0.2s ease all;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 1;
	margin-top: 0;
	top: 0;

	&.swiper-button-disabled {
		opacity: 0.3 !important;
		transition: 0.2s ease all;
		pointer-events: none;

		.hero_header_slider & {
			opacity: 0.3 !important;
		}
	}

	svg {
		height: 18px;
		transition: 0.2s ease all;

		path {
			fill: var(--gum-green);
			transition: 0.2s ease all;
		}
	}

	&:hover {
		transition: 0.2s ease all;
		transform: scale(1.1) !important;

		svg {
			height: 18px;
			transition: 0.2s ease all;

			path {
				fill: var(--gum-green);
				transition: 0.2s ease all;
			}
		}
	}

	&:focus {
		transition: 0.2s ease all;
		background: #dba769;

		svg {
			height: 18px;
			transition: 0.2s ease all;

			path {
				fill: var(--gum-green);
				transition: 0.2s ease all;
			}
		}
	}

	&.next {
		margin-right: 0;
		right: 0;

		svg {
			width: 25px;
		}
	}

	&.prev {
		/* transform: rotate(180deg); */
		margin-left: 0;
		left: 0;

		svg {
			width: 25px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/CarouselArrow.vue